const html = document.querySelector('html');
const body = document.querySelector('body');
const header = document.querySelector('.header');
const breakpoints = {
	mobile: '375px',
	tablet: '768px',
	desktop: '1240px',
	wide: '1600px',
};

const bodyWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
const scrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;
const headerHeight = () => document.querySelector('.header').offsetHeight;
const footerHeight = () => document.querySelector('.footer').offsetHeight;

// get height and position of elements
function offsetData() {
	html.setAttribute(
		'style',
		`--body-width: ${bodyWidth()}px; --scrollbar-width: ${scrollbarWidth()}px; --header-height: ${headerHeight()}px; --footer-height: ${footerHeight()}px;`,
	);
}

window.onload = () => {
	offsetData();
};

window.addEventListener('resize', offsetData, { passive: true });

export { html, body, header, breakpoints, bodyWidth };
